<template>
  <div id="scroll-progress">
    <div style="position: relative">
      <div id="indicator">
        <div style="color: white; font-size: 18px">
          {{ scrollIndicator }}
        </div>
      </div>
      <div class="scroll-track"></div>
      <div class="scroll-indicator"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "indicator",
  components: {},

  data: () => ({
    scrollIndicator: "0%",
  }),
  computed: {},
  methods: {
    handleScroll() {
      const bar = document.querySelector(".scroll-indicator");
      if (!bar) return;

      // ใช้ window scroll แทน main element
      const scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop ||
        0;
      const scrollHeight =
        document.documentElement.scrollHeight || document.body.scrollHeight;
      const clientHeight =
        window.innerHeight || document.documentElement.clientHeight;

      // ตรวจสอบว่าค่าต่างๆ มีค่าที่ถูกต้อง
      const totalScrollable = scrollHeight - clientHeight;

      if (totalScrollable <= 0) {
        this.scrollIndicator = "0%";
        bar.style.width = "0%";
        return;
      }

      const scrolled = Math.min(
        100,
        Math.max(0, (scrollTop / totalScrollable) * 100)
      );

      // ตรวจสอบ NaN
      if (isNaN(scrolled)) {
        this.scrollIndicator = "0%";
        bar.style.width = "0%";
        return;
      }

      bar.style.width = scrolled + "%";
      this.scrollIndicator = Math.floor(scrolled) + "%";
    },
  },
  mounted() {
  this.bar = document.querySelector(".scroll-indicator");
  
  // ใช้เฉพาะ window scroll
  window.addEventListener("scroll", this.handleScroll);
  
  // เรียก handleScroll ครั้งแรกเพื่อตั้งค่าเริ่มต้น
  this.$nextTick(() => {
    this.handleScroll();
  });
},
beforeDestroy() {
  window.removeEventListener("scroll", this.handleScroll);
}
};
</script>

<style lang="scss">
#scroll-progress {
  position: fixed;
  bottom: 0;
  left: var(--drawer-width, 0); /* เริ่มจากขอบขวาของ sidebar */
  right: 0;
  z-index: 1000;
  width: calc(100% - var(--drawer-width, 0)); /* ลบความกว้างของ sidebar */
}

#indicator {
  position: absolute;
  left: 8px;
  bottom: 18px;
  padding: 8px 12px;
  min-width: 50px;
  background-color: #f28330;
  z-index: 1001;
  border-radius: 8px;
  font-size: 12px;
  color: white;
}

body {
  width: 100%;
  height: 100%;
}

.scroll-track {
  width: 100%;
  height: 6px;
  background: #e0e0e0;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 999;
}

.scroll-indicator {
  width: 0%;
  height: 6px;
  background: #f28330;
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 1000;
}

section {
  width: 100%;
  height: 100vh;
  background: #000;
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
}
</style>
